module.exports = __webpack_public_path__ + "img/apio.8d3bc08c.png";